import React, {Fragment, useContext, useState, useEffect } from "react";
import {
    Button,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    ModalHeader,
    Col,
} from "reactstrap";
import { RootStoreContext } from "../../core/store/rootStore";
import LoadingOverlay from "react-loading-overlay";
import {toast} from "react-toastify";

const CompaniesModal = () => {
    const rootStore = useContext(RootStoreContext);
    const { newCompany, edit, save, loadCompany } = rootStore.companiesStore;
    const { closeModal, modal } = rootStore.modalStore;

    let [loading, setLoading] = useState(false);
    let [editableCompany, setEditableCompany, companyId] = useState(newCompany());

    useEffect(() => {
        if (modal.content && modal.content.id) {
            companyId = modal.content.id;

            let apiCompany = {...editableCompany};

            setLoading(true);
            loadCompany(companyId).then(userResult => {
                setLoading(false);
                apiCompany.id = userResult.id;
                apiCompany.name = userResult.name;

                setEditableCompany(apiCompany);
            });
        }
    }, [modal.content]);

    function saveCompany(event) {
        event.preventDefault();

        if (editableCompany.id) {
            edit(editableCompany.id, editableCompany).then(result => {
                if (result.success) {
                    toast.success("Company has been edited successfully");

                    closeModal(result.success);
                }
            });
        }
        else {
            save(editableCompany).then(result => {
                if (result.success) {
                    toast.success("Company has been saved successfully");

                    closeModal(result.success);
                }
            });
        }
    }

    const inputChange = (e) => {
        const { name, value } = e.target;
        let realValue = value;

        if (JSON.parse(e.target.getAttribute("data-number")))
            realValue = Number(realValue);

        setEditableCompany((lastUpdate) => ({
            ...lastUpdate,
            [name]: realValue,
        }));
    };

    return (
        <Fragment>
            <Form onSubmit={saveCompany}>
                <LoadingOverlay
                    active={loading}
                    spinner>
                    <ModalHeader>Gestion de l'enterprise</ModalHeader>
                    <ModalBody>
                        <FormGroup row>
                            <Label for="name" sm={4}>Nom</Label>
                            <Col sm={8}>
                                <Input
                                    type="text"
                                    name="name"
                                    id="name"
                                    required="required"
                                    value={editableCompany.name}
                                    onChange={inputChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="email" sm={4}>E-Mail</Label>
                            <Col sm={8}>
                                <Input
                                    type="email"
                                    name="email"
                                    id="email"
                                    required={!editableCompany.id}
                                    disabled={editableCompany.id}
                                    value={editableCompany.email}
                                    onChange={inputChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row >
                            <Label for="name" sm={4}>Nom de l'administrateur</Label>
                            <Col sm={8}>
                                <Input
                                    type="text"
                                    name="adminUserName"
                                    id="adminUserName"
                                    required={!editableCompany.id}
                                    disabled={editableCompany.id}
                                    value={editableCompany.adminUserName}
                                    onChange={inputChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="password" sm={4}>Mot de passe</Label>
                            <Col sm={8}>
                                <Input
                                    type="password"
                                    name="adminPassword"
                                    id="adminPassword"
                                    required={!editableCompany.id}
                                    disabled={editableCompany.id}
                                    value={editableCompany.adminPassword}
                                    onChange={inputChange}
                                />
                            </Col>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={closeModal}>
                            Annuler
                        </Button>
                        <Button type="submit" color="primary" className={"ml-2"}>
                            Sauvegarder
                        </Button>
                    </ModalFooter>
                </LoadingOverlay>
            </Form>
        </Fragment>
    );
};

export default CompaniesModal;
